import branch from '@/api/corporate/branch-profile'

import { baseState, baseMutations } from '@/store/mixins'
import { isEmpty } from 'lodash'

export const state = {
	...baseState
}

export const getters = {}

export const mutations = {
	...baseMutations
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
			},
			attrubutes
		)
		return branch.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	store(context, data) {
		return branch.store(data)
	},
	update(context, { id, data }) {
		return branch.update(id, data)
	},
	async find(context, id) {
		if (isEmpty(context.state.edit_data)) {
			let response = await branch.find(id)
			context.commit('SET_EDIT_DATA', response.data)
		}
	},
	destroy(context, id) {
		return branch.destroy(id)
	},
	getFormViewData() {
		return branch.formModel()
	}
}
